import { CloseOutlined } from "@mui/icons-material";
import { Box, Modal } from "@mui/material";

const ConfirmationModal = ({
  showModal,
  onCloseModal,
  headerText,
  btnText,
  btnActtion,
  additionalInfoDiv,
  children,
}: {
  showModal: boolean;
  onCloseModal: () => void;
  headerText: string;
  btnText: string;
  btnActtion: () => void;
  additionalInfoDiv?: JSX.Element;
  children: JSX.Element;
}) => {
  return (
    <Modal
      className="confirmation-modal-bg"
      open={showModal}
      onClose={onCloseModal}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="confirmation-modal">
        <div className="modal-close-button" onClick={onCloseModal}>
          <CloseOutlined />
        </div>
        <div className="modal-image"></div>
        <div className="text-center">
          <div className="modal-header">{headerText}</div>
          {children}
        </div>
        <button onClick={btnActtion} className="filled-button">
          {btnText}
        </button>
        {additionalInfoDiv}
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
